/**
 * Cart Drawer – Continue Shopping Visibility Fix
 * Trade theme safe patch
 */

document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  const continueBtn = cartDrawer.querySelector('[data-cart-continue]');
  if (!continueBtn) return;

  // Always hide initially to prevent flash
  continueBtn.style.visibility = 'hidden';

  /**
   * Show / hide button based on drawer state
   */
  const toggleContinueButton = () => {
    const isOpen =
      cartDrawer.hasAttribute('open') ||
      cartDrawer.classList.contains('active') ||
      cartDrawer.classList.contains('is-active');

    continueBtn.style.visibility = isOpen ? 'visible' : 'hidden';
  };

  // Run once after load
  toggleContinueButton();

  // Observe drawer state changes
  const observer = new MutationObserver(toggleContinueButton);

  observer.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ['class', 'open']
  });
});

customElements.whenDefined('cart-drawer').then(() => {
  document.querySelectorAll('cart-drawer').forEach(drawer => {
    drawer.style.display = '';
  });
});